module.exports = __webpack_public_path__ + "static/media/Cash.af0f389e.mp3";